import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { loginUser } from '../../apis/userAPI';
import { createToken } from '../../apis/sessionTokenAPI';
import './login_page.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Remove currentUser value when landing on this page.
    if (localStorage.getItem('currentUser')) {
      localStorage.removeItem('currentUser');
    }

    // Show a one-time notice left behind by an automatic session-expiry logout.
    const loginNotice = sessionStorage.getItem('loginNotice');
    if (loginNotice) {
      sessionStorage.removeItem('loginNotice');
      setError(loginNotice);
    }
  }, []);

  // Login function. If login successful, create a session token and navigate to the main page
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await loginUser({ email, password });
      const user = data.user;
      if (!user) {
        throw new Error('Login response missing user data');
      }
      setSuccess('Login successful!');
      setError('');
      
      // Create session token (this will set the cookie automatically)
      const sessionToken = await createToken({newEmail: email});
      console.log("session token created at handleSubmit:", sessionToken.message);
      
      // Store user info in localStorage (not the token)
      localStorage.setItem('currentUser', JSON.stringify(user));

      navigate('/main', { state: { currentUser: user} });
    } 
    catch (err) 
    {
      setError(err.message || 'Invalid Username or Password');
      setSuccess('');
    }
  };

  useEffect(() => {
    let timer;
    if (success || error) {
      timer = setTimeout(() => {
        setSuccess('');
        setError('');
      }, 10000);
    }
    return () => clearTimeout(timer);
  }, [success, error]);



  return (
    <div className="login-container theme-transition">
      <div className="login-box">
        <div className="login-image-container">
          <div className="login-caption">Capsule Endoscopy Anywhere, Anytime.</div>
          <img
            src={`${process.env.PUBLIC_URL}/capsocloud.jpg`}
            alt="Capsule Endoscopy"
            className="login-image"
          />
        </div>
        <div className="login-form-container">
          <div className="login-form-wrapper">
            <h1 className="login-title">Login</h1>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label" htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  autoComplete="off"
                  placeholder="your.email@example.com"
                />
              </div>
              
              <div className="form-group mt-4">
                <label className="form-label" htmlFor="password">Password</label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-input password-input"
                    autoComplete="off"
                    placeholder="***************"
                  />
                  <IconButton
                    type="button"
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="password-toggle-button"
                    size="small"
                    tabIndex={-1}
                  >
                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                  </IconButton>
                </div>
              </div>
              
              <button type="submit" className="form-button">
                Log in
              </button>
            </form>
            
            {error && <p className="form-error">{error}</p>}
            {success && <p className="form-success">{success}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
